// Single source of truth for "what do we show as this order's number".
//
// Orders created after migration 029 carry a server-generated order_number
// (AHP2802 + DDMMYY + same-day sequence, e.g. AHP28022006261). Orders from
// before that migration have order_number: null — fall back to the old
// short-UUID display ("#" + first 8 chars of id, uppercased) so historical
// orders, receipts, and emails still read sensibly.
export function orderNumber(order) {
  if (!order) return "";
  return order.order_number || `#${(order.id || "").slice(0, 8).toUpperCase()}`;
}
